<template>
  <div class="main-content bg-default">
    <!-- Navbar -->
    <base-nav class="navbar-top navbar-horizontal navbar-dark" containerClasses="pa-5" expand>
      <router-link slot="brand" class="navbar-brand" to="/">
        <img src="https://growbiotech-prod.s3.amazonaws.com/1606973000233.png" />
      </router-link>
    </base-nav>
    <!-- Header -->
    <div class="header padding-section">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <slide-y-up-transition mode="out-in" origin="center top">
        <router-view></router-view>
      </slide-y-up-transition>
    </div>
  </div>
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  name: "auth-layout",
  components: {
    SlideYUpTransition
  },
  data() {
    return {
      year: new Date().getFullYear(),
      showMenu: false
    };
  }
};
</script>
<style>
.bg-default {
  height: 100% !important;
}
.padding-section {
  padding-top: 100px !important;
  padding-bottom: 100px !important;
}
/* .nav-link.active span {
    color: #000;
} */
</style>
